import { useContext } from 'react';

import { PaymentsContext } from '../contexts';

export const usePaymentsForm = () => {
  const { paymentsSDK } = useContext(PaymentsContext);
  return paymentsSDK;
};
